import { createStyles } from '@mantine/styles';

var useStyles = createStyles({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden"
  }
});

export default useStyles;
//# sourceMappingURL=LoadingOverlay.styles.js.map
